import _ from 'lodash'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'
import { PlotTypeTopLevelView } from '../serie/edit-serie-menu'
import plotTypeOptionTemplate from '../serie/plot-type-option.hbs'
import plotTypes from '../serie/plot-types'
import $ from 'jquery'
import Dropzone from '../../edit/dropzone'
import BootslideEditMenu from '../bootslide-edit-menu'
import FeatureView from '../feature-view'
import template from './stack.hbs'
import SerieView from '../serie/serie-view'
import ChartDesignerStack from '../../model/chart-designer-stack'

const Stack = FeatureView.extend({

	className: FeatureView.prototype.className + ' stack',

	events: _.extend({
		'click': 'onEdit' // calls FeatureView.onEdit()
	}, FeatureView.prototype.events),

	initialize: function() {
		FeatureView.prototype.initialize.apply(this, arguments)

		this.serieViews = []
		this.dropzones = []
	},

	renderContent: function() {
		let stackAttrs = this.options.model.attributes
		let context = _.extend({}, stackAttrs, {
			serieCount: this.model.children.length,
			stackIcon: `stacked-${stackAttrs.plotType}`,
			label: this.chart.featureLabel({ feature: this.model })
		})
		this.$el.empty().append(template(context))
		this.attachTooltipTo = this.$('.info')
		this.renderSeries()
	},

	/**
	 * @param {Event} e
	 */
	createEditMenu(e) {
		return new EditStackMenu({
			model: this.chart,
			feature: this.model
		})
	},

	paint: function() {
		this.renderContent()
	},

	renderSeries: function() {
		this.$('.children-list').empty()
		_.invokeMap([...this.serieViews, ...this.dropzones], 'remove')
		this.serieViews = []
		this.dropzones = []

		// Add an initial dropzone at the beginning of the serie list
		let topDropzone = new Dropzone({
			parent: this.model,
			axis: this.model.get('axis'),
			panel: this.options.panel
		})
		this.dropzones.push(topDropzone)
		this.$('.children-list').append(topDropzone.el)
		topDropzone.render()

		const series = _.get(this.model, 'children.models', [])
		_.each(series, serie => {
			// Add a dropzone for each rendered serie
			let bottomDropzone = new Dropzone({
				parent: this.model,
				model: serie,
				panel: this.options.panel
			})
			this.dropzones.push(bottomDropzone)

			let serieView = new SerieView({
				model: serie,
				chart: this.chart,
				parentFeatureModel: this.model,
				topDropzone: topDropzone,
				bottomDropzone: bottomDropzone
			})

			// This will trigger the removal of all tooltips
			this.listenTo(serieView, 'edit', () => this.trigger('edit'))

			this.serieViews.push(serieView)
			this.$('.children-list').append(serieView.el)
			serieView.render()
			this.$('.children-list').append(bottomDropzone.el)
			bottomDropzone.render()

			topDropzone = bottomDropzone
		})
	},

	inactive: function() {
		FeatureView.prototype.inactive.apply(this, arguments)
		_.invokeMap(this.serieViews, 'inactive')
	},

	remove: function() {
		FeatureView.prototype.remove.apply(this, arguments)
		_.invokeMap([ ...this.serieViews, ...this.dropzones ], 'remove')
	}
})

/**
 * @extends BootslideEditMenu
 */
const EditStackMenu = BootslideEditMenu.extend(/** @lends EditStackMenu.prototype */{

	initialize: function(options = {}) {
		BootslideEditMenu.prototype.initialize.apply(this, arguments)
		this.stack = this.feature
	},

	addTopLevelOptions: function(topLevel) {
		topLevel.push(this.createEditLabelOption({ optionLabel:
			'charts.feature.stack.setStackLabel' }))

		/*
		NOTE: #40324 hide 'Set Sorting' and 'Chart Type' until they are
		- implemented and functional

		topLevel.push({ label: i18n.get('charts.setSorting') })
		topLevel.push(this.stackTypeMenu())
		*/

		if (this.stack.get('plotType') === 'bar') {
			topLevel.push(this.createFullHeightToggleOption(this.stack, this.model))
		}

		topLevel.push(this.createCopyOption(this.stack, ChartDesignerStack))
		topLevel.push(this.createDeleteOption())
	},

	createFullHeightToggleOption: function(stack, chart) {
		return {
			contentView: new FullHeightToggle({
				model: stack,
				chart
			}),
			model: stack
		}
	},

	stackTypeMenu: function() {
		let stackTypes = _.filter(plotTypes(),
			plotType => plotType.type == 'bar' || plotType.type == 'area')

		let stackTypeOptions = _.map(stackTypes, type => {
			return {
				label: type.label,
				contentView: new PlotTypeOption({
					plotType: type.type,
					icon: `stacked-${type.icon}`,
					label: type.label,
					model: this.stack,
					chart: this.model
				})
			}
		})

		return {
			label: i18n.get('dashboards.graphType'),
			contentView: new PlotTypeTopLevelView({ model: this.stack }),
			target: stackTypeOptions,
			width: 200
		}
	}
})

const PlotTypeOption = BootslideMenu.MultipleChoiceOption.extend({
	property: 'plotType',

	initialize: function (opt) {
		this.value = opt.plotType

		BootslideMenu.MultipleChoiceOption.prototype.initialize.apply(this, arguments)

		this.label = $(plotTypeOptionTemplate({
			icon: opt.icon,
			label: opt.label
		}))[0]
	},

	/**
	 * @override
	 */
	updateModel: function (value) {
		this.model.set('plotType', value)
	}
})

const FullHeightToggle = BootslideMenu.ToggleProperty.extend({
	property: {
		label: 'charts.chart.fullHeight',
		name: 'fullHeight'
	},

	initialize: function(options = {}) {
		BootslideMenu.ToggleProperty.prototype.initialize.apply(this, arguments)
		this.chart = options.chart
	},

	/**
	 * @override
	 */
	updateModel: function (value) {
		let stacks = this.chart.getFeatures(
			{ axis: this.model.get('axis'), type: 'stack' })

		// get all the bar stacks on the current axis and set the value for each
		// all bar stacks should maintain the same fullHeight value
		stacks = _.filter(stacks, stack => stack.get('plotType') === 'bar')
		_.each(stacks, stack => stack.set('fullHeight', value))
	}
})

export default Stack

Stack.__filename__ = 'charts/edit/analytics/stack.js'
